import { useHasFeatureFlag } from '@bringg-frontend/hooks';

export const useGetServiceAreaRootUrl = () => {
	const serviceAreaFromSideMenu = useHasFeatureFlag('dispatcher_new_side_menu_items');
	// After dispatcher_new_side_menu_items release `/merchant/service-areas` should be removed
	return serviceAreaFromSideMenu ? '/service-areas' : '/merchant/service-areas';
};
